/* BEDROCK offers tab — dismiss + copy-to-clipboard only.
   Drawer behavior (toggle, Esc, focus trap, scroll lock) is Dawn's MenuDrawer
   (global.js). All buttons are injected here, after the custom element has
   upgraded: MenuDrawer's constructor auto-binds any <button> present in the
   initial DOM as a submenu-close button (which skips scroll-lock cleanup), so
   the tab dismiss ×, the drawer close × and the copy buttons must not exist at
   upgrade time. Without JS none of them render and the section degrades to a
   native <details> with plain selectable code text. */

(function () {
  var STORAGE_KEY = 'bedrock-offers-dismissed';

  function dismissed() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var scratch = document.createElement('textarea');
      scratch.value = text;
      scratch.setAttribute('readonly', '');
      scratch.style.position = 'fixed';
      scratch.style.opacity = '0';
      document.body.appendChild(scratch);
      scratch.select();
      var ok = document.execCommand('copy');
      scratch.remove();
      ok ? resolve() : reject(new Error('copy failed'));
    });
  }

  function init(root) {
    if (!root || root.dataset.bedrockOffersInit) return;
    root.dataset.bedrockOffersInit = '1';

    var summary = root.querySelector('summary');
    var header = root.querySelector('.bedrock-offers__header');
    if (!summary || !header) return;

    var designMode = window.Shopify && window.Shopify.designMode;
    if (!designMode && dismissed()) {
      root.hidden = true;
      return;
    }

    var live = document.createElement('p');
    live.className = 'visually-hidden';
    live.setAttribute('role', 'status');
    root.appendChild(live);

    var dismiss = document.createElement('button');
    dismiss.type = 'button';
    dismiss.className = 'bedrock-offers__dismiss';
    dismiss.setAttribute('aria-label', root.dataset.dismissLabel);
    dismiss.textContent = '×';
    dismiss.addEventListener('click', function () {
      try {
        if (!designMode) sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (error) {
        /* storage unavailable: dismissal lasts this page only */
      }
      root.hidden = true;
    });
    root.appendChild(dismiss);

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'bedrock-offers__close';
    close.setAttribute('aria-label', root.dataset.closeLabel);
    close.textContent = '×';
    close.addEventListener('click', function () {
      summary.click();
    });
    header.appendChild(close);

    root.querySelectorAll('[data-bedrock-offer-code]').forEach(function (pill) {
      var codeEl = pill.querySelector('code');
      if (!codeEl) return;
      var copy = document.createElement('button');
      copy.type = 'button';
      copy.className = 'bedrock-offers__copy';
      copy.textContent = root.dataset.copyLabel;
      copy.addEventListener('click', function () {
        copyText(codeEl.textContent.trim()).then(function () {
          copy.textContent = root.dataset.copiedLabel;
          copy.classList.add('bedrock-offers__copy--done');
          live.textContent = root.dataset.copiedAnnouncement;
          setTimeout(function () {
            copy.textContent = root.dataset.copyLabel;
            copy.classList.remove('bedrock-offers__copy--done');
            live.textContent = '';
          }, 2000);
        });
      });
      pill.appendChild(copy);
    });
  }

  function initAll() {
    document.querySelectorAll('menu-drawer.bedrock-offers').forEach(init);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('menu-drawer.bedrock-offers');
    if (root) init(root);
  });
})();
